<div>
    <r1-compass-lib-instructions headerText="Field Mapping">
        Add rows below by clicking '+Add' to map fields to Salesforce Play and/or Recommendation object fields. Use the
        icon to choose between Data Mart fields and Additional fields. Then, select the Salesforce object and field it
        should map to.
    </r1-compass-lib-instructions>
    @for (form of formArray.controls; track form; let $arrayIndex = $index) {
        <form [formGroup]="form">
            <r1-compass-lib-field-mapping
                [index]="$arrayIndex"
                [totalRequiredRows]="requiredPredefinedFieldsLength()"
                [rowOptionButtons]="[{ value: 'delete', display: 'Delete', show: true }]"
                (clickOption)="deleteMapperRow($arrayIndex)">
                <div class="field-mapping-row">
                    <div class="field-mapping-container">
                        <div class="fieldType-toggle">
                            @switch (form.controls.fieldType.value) {
                                @case ('dataMart') {
                                    <button
                                        mat-icon-button
                                        (click)="setFieldType('definedField', $arrayIndex)"
                                        type="button"
                                        matTooltip="Switch from Datamart">
                                        <fa-icon icon="database" />
                                    </button>
                                }
                                @case ('definedField') {
                                    <button
                                        mat-icon-button
                                        (click)="setFieldType('predefinedField', $arrayIndex)"
                                        type="button"
                                        matTooltip="Switch from Defined Field">
                                        <fa-icon icon="plus" />
                                    </button>
                                }
                                @case ('predefinedField') {
                                    @if ($arrayIndex >= requiredPredefinedFieldsLength()) {
                                        <button
                                            mat-icon-button
                                            (click)="setFieldType('dataMart', $arrayIndex)"
                                            type="button"
                                            matTooltip="Switch from Predefined Field">
                                            <fa-icon icon="check" />
                                        </button>
                                    }
                                }
                            }
                        </div>

                        <div class="field-mapping-content">
                            @if (form.controls.fieldType.value === 'dataMart') {
                                <mat-form-field class="field-mapping-form-field">
                                    <mat-label>Datamart Field </mat-label>
                                    <mat-select
                                        formControlName="sourceField"
                                        (selectionChange)="onSourceFieldChanged($arrayIndex)">
                                        @for (field of filteredDataMartValues()[$arrayIndex]; track $index) {
                                            <mat-option [value]="field?.name"
                                                >{{ field?.displayName }} ({{ field?.name }})
                                            </mat-option>
                                        }
                                    </mat-select>
                                    @if (form.controls.sourceField.errors?.['req']) {
                                        <mat-error>Field is required</mat-error>
                                    } @else if (form.controls.sourceField.errors?.['dataTypeMismatch']) {
                                        <mat-error>Field type mismatch</mat-error>
                                    }
                                </mat-form-field>
                            } @else if (form.controls.fieldType.value === 'definedField') {
                                <mat-form-field class="field-mapping-form-field">
                                    <mat-label>Defined Field</mat-label>
                                    <mat-select
                                        formControlName="sourceField"
                                        (selectionChange)="onSourceFieldChanged($arrayIndex)">
                                        @for (field of filteredDefinedFieldValues()[$arrayIndex]; track $index) {
                                            <mat-option [value]="field.id">{{ field.name }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (form.controls.sourceField.errors?.['req']) {
                                        <mat-error>Field is required</mat-error>
                                    } @else if (form.controls.sourceField.errors?.['dataTypeMismatch']) {
                                        <mat-error>Field type mismatch</mat-error>
                                    }
                                </mat-form-field>
                            } @else if (
                                form.controls.fieldType.value === 'predefinedField' &&
                                $arrayIndex >= requiredPredefinedFieldsLength()
                            ) {
                                <mat-form-field class="field-mapping-form-field">
                                    <mat-label>Predefined Field</mat-label>
                                    <mat-select
                                        formControlName="sourceField"
                                        (selectionChange)="onSourceFieldChanged($arrayIndex)">
                                        @for (field of predefinedFields; track $index) {
                                            <mat-option
                                                [value]="field.id"
                                                (click)="form.controls.id.setValue(field.id + '-' + Uuid.generate())"
                                                >{{ field.name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            } @else if (
                                form.controls.fieldType.value === 'predefinedField' &&
                                $arrayIndex < requiredPredefinedFieldsLength()
                            ) {
                                @switch ($arrayIndex) {
                                    @case (0) {
                                        Play ID *
                                    }
                                    @case (1) {
                                        Play Internal Name *
                                    }
                                    @case (2) {
                                        Play Salesforce Name *
                                    }
                                }
                            }
                        </div>

                        <!-- The styling of the r1-compass-lib-field-field is weird with toggle group, needs wrapper -->
                        <div class="field-mapping-content">
                            <div class="toggle-div">
                                <mat-button-toggle-group
                                    formControlName="mappingType"
                                    hideSingleSelectionIndicator="true"
                                    (click)="forceValidation($arrayIndex)">
                                    <mat-button-toggle value="play">Play</mat-button-toggle>
                                    @if ($arrayIndex >= requiredPredefinedFieldsLength()) {
                                        <mat-button-toggle value="rec">Rec</mat-button-toggle>
                                    }
                                    <mat-button-toggle value="both">Both</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                        <!-- From SF Play Obj -->
                        @switch (form.value.mappingType) {
                            @case ('play') {
                                <div class="field-mapping-content">
                                    <mat-form-field class="field-mapping-form-field">
                                        <mat-label>Play Field</mat-label>
                                        <mat-select
                                            formControlName="targetPlayField"
                                            (selectionChange)="onTargetPlayFieldChanged($arrayIndex)">
                                            @for (field of filteredPlayValues()[$arrayIndex]; track i; let i = $index) {
                                                <mat-option
                                                    [value]="field.value.name"
                                                    [disabled]="
                                                        filteredPlayValues()[$arrayIndex][i].reservedBy !==
                                                            $arrayIndex &&
                                                        filteredPlayValues()[$arrayIndex][i].reservedBy !== -1
                                                    "
                                                    >{{ field.value.label }} ({{ field.value.name }})
                                                </mat-option>
                                            }
                                        </mat-select>
                                        @if (form.controls.targetPlayField.errors?.['req']) {
                                            <mat-error>Field is required</mat-error>
                                        } @else if (form.controls.targetPlayField.errors?.['dataTypeMismatch']) {
                                            <mat-error>Field type mismatch</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="field-mapping-content"></div>
                                <!-- Empty Div for spacing -->
                            }
                            @case ('rec') {
                                <div class="field-mapping-content"></div>
                                <!-- Empty Div for spacing -->
                                <div class="field-mapping-content">
                                    <mat-form-field class="field-mapping-form-field">
                                        <mat-label>Recommendation Field</mat-label>
                                        <mat-select
                                            formControlName="targetRecommendationField"
                                            (selectionChange)="onTargetRecommendationFieldChanged($arrayIndex)">
                                            @for (
                                                field of filteredRecommendationValues()[$arrayIndex];
                                                track i;
                                                let i = $index
                                            ) {
                                                <mat-option
                                                    [value]="field.value.name"
                                                    [disabled]="
                                                        filteredRecommendationValues()[$arrayIndex][i].reservedBy !==
                                                            $arrayIndex &&
                                                        filteredRecommendationValues()[$arrayIndex][i].reservedBy !== -1
                                                    "
                                                    >{{ field.value.label }} ({{ field.value.name }})
                                                </mat-option>
                                            }
                                        </mat-select>
                                        @if (form.controls.targetRecommendationField.errors?.['req']) {
                                            <mat-error>Field is required</mat-error>
                                        } @else if (
                                            form.controls.targetRecommendationField.errors?.['dataTypeMismatch']
                                        ) {
                                            <mat-error>Field type mismatch</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            }
                            @case ('both') {
                                <div class="field-mapping-content">
                                    <mat-form-field class="field-mapping-form-field">
                                        <mat-label>Play Field</mat-label>
                                        <mat-select
                                            formControlName="targetPlayField"
                                            (selectionChange)="onTargetPlayFieldChanged($arrayIndex)">
                                            @for (field of filteredPlayValues()[$arrayIndex]; track i; let i = $index) {
                                                <mat-option
                                                    [value]="field.value.name"
                                                    [disabled]="
                                                        filteredPlayValues()[$arrayIndex][i].reservedBy !==
                                                            $arrayIndex &&
                                                        filteredPlayValues()[$arrayIndex][i].reservedBy !== -1
                                                    "
                                                    >{{ field.value.label }} ({{ field.value.name }})
                                                </mat-option>
                                            }
                                        </mat-select>
                                        @if (form.controls.targetPlayField.errors?.['req']) {
                                            <mat-error>Field is required</mat-error>
                                        } @else if (form.controls.targetPlayField.errors?.['dataTypeMismatch']) {
                                            <mat-error>Field type mismatch</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="field-mapping-content">
                                    <mat-form-field class="field-mapping-form-field">
                                        <mat-label>Recommendation Field</mat-label>
                                        <mat-select
                                            formControlName="targetRecommendationField"
                                            (selectionChange)="onTargetRecommendationFieldChanged($arrayIndex)">
                                            @for (
                                                field of filteredRecommendationValues()[$arrayIndex];
                                                track i;
                                                let i = $index
                                            ) {
                                                <mat-option
                                                    [value]="field.value.name"
                                                    [disabled]="
                                                        filteredRecommendationValues()[$arrayIndex][i].reservedBy !==
                                                            $arrayIndex &&
                                                        filteredRecommendationValues()[$arrayIndex][i].reservedBy !== -1
                                                    "
                                                    >{{ field.value.label }} ({{ field.value.name }})
                                                </mat-option>
                                            }
                                        </mat-select>
                                        @if (form.controls.targetRecommendationField.errors?.['req']) {
                                            <mat-error>Field is required</mat-error>
                                        } @else if (
                                            form.controls.targetRecommendationField.errors?.['dataTypeMismatch']
                                        ) {
                                            <mat-error>Field type mismatch</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            }
                            @default {
                                <!-- Default when row is added -->
                                <div class="field-mapping-content"></div>
                                <div class="field-mapping-content"></div>
                            }
                        }
                    </div>
                </div>
            </r1-compass-lib-field-mapping>
        </form>
    }
    <button mat-raised-button color="primary" (click)="addMapperRow()" type="button">+Add</button>
</div>
